<div class="sp-detail">
	<div class="sp-detail-left">
		<div class="sp-detail1">
			<h3>{{ sp?.name }}</h3>

			{{ sp?.physical_addr }} <br />
			{{ sp?.physical_city }} <br />
			{{ sp?.physical_code }}
		</div>
		<div class="sp-detail2">
			<div>
				<div class="left">To:</div>
				<div class="right">{{ invoice?.to_name }}</div>
			</div>
			<div>
				<div class="left">Address:</div>
				<div class="right">{{ invoice?.to_address_1 }}, {{ invoice?.to_address_2 }}, {{ invoice?.to_postal_code }}</div>
			</div>
			<div>
				<div class="left">VAT Number:</div>
				<div class="right">{{ invoice?.to_vat_number }}</div>
			</div>
		</div>
	</div>

	<div class="sp-detail-right">
		<div class="sp-detail3">
			<div>
				<div class="left">VAT Number:</div>
				<div class="right">{{ sp?.vat_no }}</div>
			</div>
			<div>
				<div class="left">Registration no.:</div>
				<div class="right">{{ sp?.co_reg }}</div>
			</div>
			<div>
				<div class="left">Contact:</div>
				<div class="right">{{ sp?.contact_primary }}</div>
			</div>
			<div>
				<div class="left">Claim #:</div>
				<div class="right">{{ invoice?.claim_number }}</div>
			</div>
			<div>
				<div class="left">Client:</div>
				<div class="right">{{ invoice?.client }}</div>
			</div>
		</div>
	</div>
	<br />
	<br />
</div>
